import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './bottom.styl'

export default class Bottom extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}
